import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import './Footer.css'; // Plain CSS (no CSS Modules)
import locationIcon from '../../assets/footer/icons8-location-48.png';
import mail from '../../assets/footer/icons8-mail-48.png';
import insta from '../../assets/footer/icons8-instagram-48.png';
import face from '../../assets/footer/icons8-facebook-48.png';
import link from '../../assets/footer/icons8-linkedin-48.png';

const Footer: React.FC = () => {
    const [email, setEmail] = useState("");

    const MAILCHIMP_SIGNUP =
        "https://virginia.us14.list-manage.com/subscribe?u=45792a76bc10b7924d7ccb62e&id=53139167b0";
    const EVENTS_CALENDAR =
        "https://calendar.google.com/calendar/u/0/r?cid=ODFlNTZjZmEyMGRmODQ1YTUyOWM1MTNlYTdkZGU4MWI0NzAyNTU3ODVhNWFjM2JkYjA4NGMzYjQwY2RmZmIwOUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t";

    const handleSubscribe = (e: React.FormEvent) => {
        e.preventDefault();

        // If email is filled, add it as a query param
        const url = email
            ? `${MAILCHIMP_SIGNUP}&EMAIL=${encodeURIComponent(email)}`
            : MAILCHIMP_SIGNUP;

        window.open(url, "_blank", "noopener,noreferrer");
    };


    return (
        <footer className="modern-footer pt-5">
            <div className="container footer-content">
                <div className="row g-4 mb-5">
                    {/* Company Info */}
                    <div className="col-lg-4 col-md-6">
                        <Link to="/" className="footer-logo d-block mb-4">
                            TSA at UVA<span className="text-primary">.</span>
                        </Link>
                        <p className="text-muted mb-4">
                            Taiwanese Student Association at the University of Virginia
                        </p>
                        <ul className="contact-info mb-4">
                            <li>
                                <img src={locationIcon} alt="Location" className="footer-icon me-2"/>
                                <a
                                    href="https://www.google.com/maps/place/Charlottesville,+VA"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Charlottesville, VA
                                </a>
                            </li>
                            <li>
                                <img src={mail} alt="Email" className="footer-icon me-2"/>
                                <a href="mailto:wpv5sg@virginia.edu">wpv5sg@virginia.edu</a>
                            </li>
                        </ul>
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-4 col-md-6">
                        <h3 className="footer-title">Quick Links</h3>
                        <ul className="quick-links">
                            <li><Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link></li>
                            <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>About TSA</Link></li>
                            <li><Link to="/events" onClick={() => window.scrollTo(0, 0)}>Events</Link></li>
                            <li><Link to="/sponsors" onClick={() => window.scrollTo(0, 0)}>Sponsors</Link></li>
                            <li><Link to="/archive" onClick={() => window.scrollTo(0, 0)}>Archive</Link></li>
                            {/*<li>
                                <a href="https://forms.gle/9Pj9cRZAejCR8DSR9" target="_blank" rel="noreferrer">
                                    Feedback/Reporting
                                </a>
                            </li>*/}
                            <li>
                                <a href="https://docs.google.com/forms/d/e/1FAIpQLSf4IVRczWQrg3PI3cbYAlGTTUQxXvyZUmfxSJ5q3UEe1pGiPA/viewform" target="_blank" rel="noreferrer">
                                    Announcement Request
                                </a>
                            </li>
                            <li>
                                <a href={EVENTS_CALENDAR} target="_blank" rel="noreferrer">
                                    Events Calendar
                                </a>
                            </li>
                            <li>
                                <a href="https://linktr.ee/tsaatuva" target="_blank" rel="noreferrer">
                                    All Links (Linktree)
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Newsletter + Social Icons */}
                    <div className="col-lg-4 col-md-12">
                        <h3 className="footer-title">Stay Connected</h3>
                        <p className="text-muted mb-4">
                            Subscribe to our newsletter for the latest updates.
                        </p>

                        {/* Email input that opens Mailchimp with email pre-filled */}
                        <form className="mb-4" onSubmit={handleSubscribe}>
                            <div className="mb-3">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="form-control newsletter-input"
                                    placeholder="Your email address"
                                />
                            </div>
                            <button type="submit" className="btn-subscribe">
                                Subscribe Now
                            </button>
                        </form>

                        <div className="social-links">
                            <a href="https://www.facebook.com/groups/tsaatuva" className="social-icon" target="_blank"
                               rel="noreferrer">
                                <img src={face} alt="Facebook"/>
                            </a>
                            <a href="https://www.instagram.com/tsaatuva" className="social-icon" target="_blank"
                               rel="noreferrer">
                                <img src={insta} alt="Instagram"/>
                            </a>
                            <a href="https://www.linkedin.com/company/tsaatuva/" className="social-icon" target="_blank"
                               rel="noreferrer">
                                <img src={link} alt="LinkedIn"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="row py-4">
                        <div className="col-md-6 text-center text-md-start">
                            <p>&copy; {new Date().getFullYear()} TSA at UVA. All rights reserved.</p>
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <p>
                                Made with ❤️ by TSA at UVA
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
